import React from 'react';
import { useAuth } from 'react-oidc-context';
import './Home.scss';

const HomePage: React.FC = () => {
  const auth = useAuth();

  const handleSignIn = () => {
    auth.signinRedirect();
  };

  return (
    <div className="home-page">
      <div className="content-container">
        <div className="logo-title-container">
          <img
            className="logo"
            alt="Alaska Airlines"
            src="https://resource.alaskaair.net/-/media/A2B28D27C57B4BB9A72557221CF779A3"
          />
          <div className="line"></div>
          <h1 className="title">Flight Range</h1>
        </div>
        <button
          className="sign-in-button"
          onClick={handleSignIn}
          aria-label="Sign in to Flight Range Admin"
        >
          Sign in
        </button>
      </div>
    </div>
  );
};

export default HomePage;